import { SemanticCOLORS } from 'semantic-ui-react';
import { Review } from '../types/review.type';

export type ReviewReplyStatus =
  'none' | 'unpublished' | 'pending' | 'validated' | 'refused';

/** Publication state of the pro reply: an unpublished review (spam or
 * refused) hides its reply whatever the reply moderation status. */
export const getReviewReplyStatus = (review: Review): ReviewReplyStatus => {
  if (!review.reply) {
    return 'none';
  }

  if (review.isSpam || review.status === 'ko') {
    return 'unpublished';
  }

  switch (review.replyStatus) {
    case 'draft':
      return 'pending';
    case 'ok':
      return 'validated';
    case 'ko':
      return 'refused';
    default:
      return 'none';
  }
};

export const reviewReplyStatusLabels: Record<
  Exclude<ReviewReplyStatus, 'none'>,
  { text: string; color: SemanticCOLORS }
> = {
  unpublished: { text: 'Non publiée', color: 'grey' },
  pending: { text: 'En attente', color: 'red' },
  validated: { text: 'Validée', color: 'green' },
  refused: { text: 'Refusée', color: 'grey' },
};
